import { render, staticRenderFns } from "./bonus-register.vue?vue&type=template&id=c8a2323c&"
import script from "./bonus-register.vue?vue&type=script&lang=js&"
export * from "./bonus-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports